import _ from 'underscore';
import { useContext } from 'react';
import type { EnvironmentLookupFn } from '../public-types';
import { EnvironmentContext } from './context';

export function useEnvironment(environmentLookupFn?: EnvironmentLookupFn) {
  const [environment, environments] = useContext(EnvironmentContext);
  if (environmentLookupFn) {
    const specificEnvironment = _.find(
      environments || [],
      candidate => candidate?.tag && environmentLookupFn(candidate.tag),
    );
    if (!_.isEmpty(specificEnvironment)) {
      return specificEnvironment;
    }
  }
  return environment || _.first(environments || []);
}
